import Swal from 'sweetalert2'
import '@sweetalert2/theme-material-ui/material-ui.css';

var UIOption = {
    // common info
    title: "",
    text: "",
    icon: "question",
    inputValue: "",
    input: "text",

    // switch
    showCancelButton: true,
    allowOutsideClick: false


}
class UI {
    otpsTransform(opts) {
        return opts;
    }

    alert(opts) {
        let swalOptions = {
            allowOutsideClick: false
        };
        if (opts['title'] !== undefined) {
            swalOptions.title = opts['title'];
        }
        if (opts['msg'] !== undefined) {
            swalOptions.text = opts['msg'];
        }
        if (opts['icon'] !== undefined) {
            swalOptions.icon = opts['icon'];
        }
        if (opts['html'] !== undefined) {
            swalOptions.html = opts['html'];
        }

    }

    blockAlert(opts) {
        let swalOptions = {
            showCloseButton: false,
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
        };
        if (opts['title'] !== undefined) {
            swalOptions.title = opts['title'];
        }
        if (opts['msg'] !== undefined) {
            swalOptions.text = opts['msg'];
        }
        if (opts['icon'] !== undefined) {
            swalOptions.icon = opts['icon'];
        }
        if (opts['html'] !== undefined) {
            swalOptions.html = opts['html'];
        }
        Swal.fire(swalOptions);
    }

    confirm(opts) {
        Swal.fire({
            title: 'Error!',
            text: 'Do you want to continue',
            icon: 'error',
            confirmButtonText: 'Cool'
        })

    }
    prompt() {

    }
    toast() {

    }
}


const ui = new UI();
export default ui;